import { render, staticRenderFns } from "./needCourseList.vue?vue&type=template&id=4e55428e&"
import script from "./needCourseList.vue?vue&type=script&lang=js&"
export * from "./needCourseList.vue?vue&type=script&lang=js&"
import style0 from "./needCourseList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports